import { createIcon } from '@chakra-ui/react';

export const AuthGradIcon = createIcon({
  displayName: 'AuthGradIcon',
  path: (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 134 134" fill="none">
      <circle
        cx="66.5551"
        cy="66.5551"
        r="66.5551"
        transform="rotate(45 66.5551 66.5551)"
        fill="url(#paint0_linear_6912_118335)"
      />
      <defs>
        <linearGradient
          id="paint0_linear_6912_118335"
          x1="0"
          y1="-1.52588e-05"
          x2="133.11"
          y2="133.11"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#5552F2" />
          <stop offset="1" stopColor="#A6E4FF" />
        </linearGradient>
      </defs>
    </svg>
  ),
});
